<template lang="pug">
    .wrapper
      .content-container
        .title-container
            h1.has-text-centered {{$t('componentes.coletor.views.listaLocaisDeTrabalho.titulo')}}
        .locais-container
            .esquerda-container
                .local(v-for="(local, index, array) in locaisDeTrabalhaDoColetor") {{ renderizarLocalIndexPar(index, local) }}
            .direita-container
                .local(v-for="(local, index, array) in locaisDeTrabalhaDoColetor") {{ renderizarLocalIndexImpar(index, local) }}
        Button3d(color="info" size="medium" :block="true" @click="redirecionarParaTelaAnterior") Voltar
</template>
<script>
export default {
  name: 'ListaLocaisDeTrabalho',
  computed: {
    locaisDeTrabalhaDoColetor () {
      const { locais } = this.$store.state.sincronizador.sincronizacaoWeb
      return locais
    }
  },
  methods: {
    renderizarLocalIndexPar (index, local) {
      return index % 2 === 0 ? local.nome : ''
    },
    renderizarLocalIndexImpar (index, local) {
      return index % 2 !== 0 ? local.nome : ''
    },
    redirecionarParaTelaAnterior () {
      const nomeDaRotaAnterior = this.$store.state.rotaAnterior.name

      if (nomeDaRotaAnterior) {
        this.$router.push({ name: nomeDaRotaAnterior })
        return
      }

      this.$router.push({ name: 'sincronizador' })
    }
  }
}
</script>

<style scoped>
.content-container {
    display: flex;
    flex-direction: column;
    width: Min(90%, 780px);
    min-height: calc(100vh - 100px- 68px);
    height: 100%;
    margin: 0 auto;
    padding-bottom: 1rem;
}

.title-container {
    width: Min(90%, 350px);
    margin: 0 auto;
}
.locais-container {
    margin: 1rem 0;
    max-height: 50vh;
    overflow-y: auto;
    display: flex;
}

@media only screen and (max-width: 600px) {
  .locais-container {
    flex-direction: column;
  }
}

.locais-container > * {
    flex: 1
}

.local {
    font-size: 1rem;
    line-height: 1.6;
}
</style>
